import { render, staticRenderFns } from "./TestSetting.vue?vue&type=template&id=0af01d13&scoped=true"
import script from "./TestSetting.vue?vue&type=script&lang=js"
export * from "./TestSetting.vue?vue&type=script&lang=js"
import style0 from "./TestSetting.vue?vue&type=style&index=0&id=0af01d13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af01d13",
  null
  
)

export default component.exports